module.exports = " <div class=returnHome @click=clickEvent v-if=isWebChat><img :src=btnImg alt=\"\"/></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ReturnBtn.vue
// module id = 147
// module chunks = 0